import styled from "styled-components"

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-bottom: 80px;
`
